import { useEffect } from "react";

import useDropboxAccount, {
  useIsDropboxer,
} from "@mirage/service-auth/useDropboxAccount";
import { useIsDfbUser } from "@mirage/shared/hooks/useIsDfbUser";
import { privacyCategoryStateAtom } from "@mirage/shared/privacy";
import { useAtomValue } from "jotai";

import { useFeatureRingSettings } from "@mirage/service-feature-ring-settings/hooks/useFeatureRingSettings";
import { initializeFullStory } from "../helpers/initializeFullStory";

export const useFullstory = () => {
  const account = useDropboxAccount();
  const isDropboxer = useIsDropboxer();
  const isDfbUser = useIsDfbUser();
  const privacyCategoryState = useAtomValue(privacyCategoryStateAtom);
  const { featureRingSettings, getCurrentFeatureRing } =
    useFeatureRingSettings();
  const featureRing = featureRingSettings?.default?.id;
  useEffect(() => {
    // Need to call this to populate the `featureRingSettings` atom
    getCurrentFeatureRing();
  }, [getCurrentFeatureRing]);

  useEffect(() => {
    if (
      account &&
      privacyCategoryState &&
      isDropboxer !== undefined &&
      isDfbUser !== undefined &&
      featureRing !== undefined
    ) {
      initializeFullStory({
        publicUserAccountId:
          account?.public_account_id && atob(account.public_account_id),
        publicUserTeamId:
          account?.team?.public_team_id && atob(account.team?.public_team_id),
        isDfbUser,
        isDropboxer,
        userAcceptedAllCookies: privacyCategoryState.all,
        userAcceptedAnalytics: privacyCategoryState.analytics,
        userInteracted: privacyCategoryState.userInteracted,
        featureRing,
      });
    }
  }, [
    privacyCategoryState,
    account,
    isDfbUser,
    isDropboxer,
    featureRing,
  ]);
};
